export default __webpack_public_path__ + "static/media/paso19.605eb15d.png";